import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const coapplicantEmploymentSectionComponent = {
  amount: 'coapplicant-employment-section.amount',
  duration: 'coapplicant-employment-section.duration',
  editLink: 'coapplicant-employment-section.edit-link',
  h3: 'coapplicant-employment-section.h3',
  incomeType: 'coapplicant-employment-section.income-type',
  root: 'coapplicant-employment-section.root',
  status: 'coapplicant-employment-section.status',
} as const satisfies ComponentLocatorMap;
